
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.932 12.236a.444.444 0 000-.472.348.348 0 00-.034-.051.491.491 0 00-.15-.137c-.01-.006-.014-.018-.025-.023l-7-3.5A.5.5 0 0016 8.5v3H.5a.5.5 0 000 1H16v3a.5.5 0 00.723.447l7-3.5c.011 0 .015-.017.025-.023a.491.491 0 00.15-.137.348.348 0 00.034-.051z"}})])
          )
        }
      }
    